// src/pages/kpi/UserCount.jsx

import React from "react";
import BaseKPIPage from "./BaseKPIPage";
import { KPI_PAGE_CONFIG } from "../constants/kpiConstants";

/**
 * User Count Analytics Page
 * Uses the reusable BaseKPIPage with specific configuration
 */
export default function UserCount() {
  return (
    <BaseKPIPage
      config={KPI_PAGE_CONFIG.userCount}
      showInterval={false}
      showEndDate={true}
      showAggregation={true}
    />
  );
}